export default __webpack_public_path__ + "static/media/swift.319ee509.png";